/*
Copyright (c) 2012-2025 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
/** @jsx jsx */
import { jsx, css } from "@emotion/core"
import { ArrowRightUniversal } from "@duxton-web/icons"
import { FC, useState } from "react"
import { useTranslationsMapTyped } from "hooks/useTranslationsMapTyped"
import { Item } from "types/models/menu"
import { OverflowTip } from "./common"

export type ItemStockManagementProps = {
  item: Item
  maxWidth: string
  onClick: () => void
}

export const ItemStockManagement: FC<ItemStockManagementProps> = ({
  item,
  maxWidth,
  onClick,
}: ItemStockManagementProps) => {
  const [isHovered, setIsHovered] = useState(false)

  const textMap = useTranslationsMapTyped({
    defaultLabel: "inventory.stock.table.noLimit",
  })

  const getStockValue = () => {
    if (item.itemStock?.enableIms) {
      return item.itemStock?.currentStock ?? textMap.defaultLabel
    }
    return textMap.defaultLabel
  }

  return (
    <div
      css={css`
        display: flex;
        cursor: pointer;
        max-width: ${maxWidth};
      `}
      onClick={onClick}
      data-testid="item-stock-management"
      onMouseOver={() => setIsHovered(true)}
      onFocus={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onBlur={() => setIsHovered(false)}
    >
      <OverflowTip>
        <span>{getStockValue()}</span>
      </OverflowTip>
      <div
        css={css`
          padding-left: 10px;
          min-width: 26px;
        `}
      >
        {isHovered && (
          <span data-testid="indicate-clickable-icon">
            <ArrowRightUniversal style={{ color: "#0091FF" }} />
          </span>
        )}
      </div>
    </div>
  )
}
